// extracted by mini-css-extract-plugin
module.exports = {"timelineItem":"styles_timelineItem__OBlHY","content":"styles_content__O_chB"};